<template>
  <div class="f1">
    <div class="text-center">
      <h1 v-if="title">
        {{ title }}
      </h1>
    </div>

    <div class="f1-steps">
      <div class="f1-progress">
        <div class="f1-progress-line" :style="{ width: progressWidth + '%' }" />
      </div>

      <wizard-step
        v-for="(step, index) in steps"
        :key="'step_' + index"
        :active="isActive(index)"
        :step="step"
        :width="itemWidth + '%'"
        @click="changeStep(index)"
      />
    </div>

    <slot />
  </div>
</template>

<script>
import WizardStep from './Step.vue';

// @vuese
// Kreator
// @group Wizard
export default {
  name: 'Wizard',
  components: { WizardStep },
  props: {
    // Tytuł
    title: {
      type: String,
      required: false
    },
    // Kroki
    steps: {
      type: Array,
      required: true
    }
  },
  computed: {
    itemWidth() {
      return 100 / this.steps.length;
    },
    progressWidth() {
      return this.itemWidth * this.activeStep + this.itemWidth / 2;
    },
    activeStep() {
      return this.steps.findIndex(step => step.name === this.$route.name);
    }
  },
  methods: {
    // @vuese
    // Sprawdza czy etap jest aktywny
    isActive(index) {
      return index <= this.activeStep;
    },
    // @vuese
    // Zmienia zakładkę
    changeStep(index) {
      // @vuese
      // Zmienia zakładkę
      this.$emit('changeStep', index);
    }
  }
};
</script>

<style>
.f1-progress-line {
  transition: width 0.3s ease;
}
.f1-step .f1-step-icon {
  transition: all 0.3s linear;
}
</style>
